import { createContext } from '@lit/context';
import type { ProductOption } from '@repobit/dex-store';

export type dataLayerPayload = {
  option: ProductOption;
  event : "all" | "info" | "comparison" | (string & {});
};

export type dataLayerContextType = ((payload: dataLayerPayload) => void) | undefined;

export const dataLayerContext = createContext<dataLayerContextType>(Symbol('dataLayer'));

